export const JOB_TYPE_ACTIONS = {
  EDIT: 'edit',
  DELETE: 'delete',
} as const;

export type JobTypeActionKey = (typeof JOB_TYPE_ACTIONS)[keyof typeof JOB_TYPE_ACTIONS];

export const JOB_TYPES_ENDPOINT = 'job_types';
